import { IGlobalLocale } from "./locale.interface";

export const ua: IGlobalLocale = {
	module: {
		menu: {
			0: {
				title: "Клієнти",
				hint: "Довідник клієнтів"
			},
			1: {
				title: "Рахунки",
				hint: "Довідник рахунків"
			},
			2: {
				title: "Карти",
				hint: "Карти клієнтів"
			},
			3: {
				title: "Звіти",
				hint: "Звіти"
			},
			4: {
				title: "Інструкції",
				hint: "Інструкції"
			},
			5: {
				title: "Налаштування",
				hint: "Налаштування"
			},
			6 :{
				title: "Переказ коштів",
				hint :"Перекази коштів між рахунками/картами"
			},
			7 :{
				title: "Моя картка",
				hint :"Моя картка"
			},
			8 :{
				title: "Документи",
				hint :"Документи"
			}
		},
		login: {
			enterCRM: 'Увійти в CRM',
			welcomeText: 'Щоб увійти в особистий кабінет, введіть номер телефону та пароль або зареєструйтесь',
			titleLogin: 'Телефон',
			titlePassword: 'Пароль',
			btnRegister: 'Реєстрація',
			btnForgotPass: 'Забули пароль',
			btnEnter: 'Увійти',
			btnLogout: 'Вийти'
		},
		register: {
			registerCRM: 'Реєстрація',
			updateCRM: 'Заміна паролю',
			welcomeTextPhone: 'Для реєстрації чи нагадування паролю, будь-ласка введіть номер телефону',
			welcomeTextOTP: 'Введіть код, який Вам було відправлено в СМС на вказаний номер телефону',
			titlePhone: 'Телефон',
			titleOTP: 'Код з СМС',
			btnRegisterPhone: 'Відправити СМС-код',
			btnRegisterOTP: 'Зареєструватись',
			btnUpdatePassOTP: 'Оновити дані',
			titleEnterPass: 'Введіть пароль',
			titleEnterRePass: 'Повтор паролю',
			titleRegisterDriver: 'Ваш номер телефону "%1%", буде прив`язаний до карти "%2%". Підтверджуєте цю дію?',
			titleRegisterDriverSuccess: 'Номер телефону "%1%", успішно прив`язаний до карти "%2%". Далі вам необхідно пройти реєстарцію.'
		},
		clientList: {
			placeholderSearchString: 'Пошук по назві або ЄДРПОУ',
			titleAccounts: 'Рахунки',
			titlePage: 'Клієнти',
			titleID: 'ID',
			titleNameClient: 'Назва клієнта',
			titleOKPO: 'ЄДРПОУ',
			titleINN: 'ІПН',
			titlePhone: 'Телефон',
			titleEmail: 'Пошта',
			titleAddress: 'Адреса',
			titleLegalAddress: 'Юридична адреса',
			titleNumContract: 'Номер договору',
			titleStatus: 'Статус клієнта',
		},
		accounts: {
			titleID: 'ID',
			titleRemark: 'Опис',
			titleRest: 'Залишок',
			titleOverdraft: 'Овердрафт',
			titleTotalBalance: 'Доступно',
			titleTotalBalanceHint: 'Баланс рахунку',
			titlePurses: 'Гаманці',
			titleTotalBalanceWithoutHold: 'Баланс',
			titleTotalBalanceWithoutHoldHint: 'Баланс рахунку без урахування холдів',
			titleCardsQty: 'Карти (кіл-ть)',
			titleCards: 'Карти',
			btnAccountLink: 'Перейти до рахунків'
		},
		cards: {
			titleID: 'Карта',
			titleVin: 'Авто',
			titlePhone: 'Телефон',
			titleName: 'Прізвище, ім\'я',
			titleActiveMobileApp: 'Мобільний додаток',
			titleSetting: 'Налаштування',
			titleConfirmRenewPin: 'Ви дійсно бажаєте змінити поточний pin?',
			titleShowNewPin: 'Новий PIN',
			titleBtnSendOtp: 'Відправити код',
			titleBtnSendRegisterLink: 'Відправити посилання на реєстрацію',
			titleCodeFromSMS: 'Код з смс',
			titleBtnCommit: 'Змінити номер',
			limits: {
				titleBtnAddLimit: 'Додати ліміт',
				titleMoneySchema: 'Гривнева схема',
				titleQtySchema: 'Літрова схема',
				titleShortMoneySchema: 'Гривнева',
				titleShortQtySchema: 'Літрова',
				titlePurses: 'Гаманці',
				titleSchemaType: 'Схема',
				titleType: 'Тип',
				titleMoneyByDay: 'Грн/Доба',
				titleQtyByDay: 'Літри/Доба',
				titleMoneyByMonth: 'Грн/Місяць',
				titleQtyByMonth: 'Літри/Місяць',
				titleMoneyByOnce: 'Грн/Разово',
				titleQtyByOnce: 'Літри/Разово',
				titleMoneyByWeek: 'Грн/Тиждень',
				titleQtyByWeek: 'Літри/Тиждень',
				titleMoneyOutOfTime: 'Грн.до списання',
				titleQtyOutOfTime: 'Літри до списання',
				titleBalance: 'Обіг',
				titleLimitAmount : 'Ліміт',
				titleRest : 'Залишок',
				newLimit: {
					title: 'Рахунок',
					titleIndividual: 'Індивідуальний',
					titleCommon: 'Загальний',
					titleTypeLimit: 'Тип ліміту',
					titleLimitAmount: 'Сума'
				}
			},
			qr: {
				notExistCard: "Картка відсутня.\n Щоб додати картку, прив'яжіть свій номер телефона до карти",
				notMatchResolution : "Не підходить роздільна здатність екрану, будь ласка, поверніть телефон",
				contextMenu: {
					blocked: 'Блокування',
					confirmBlockedCard: 'Ви дійсно бажаєте заблокувати карту?',
					limits: 'Перегляд лімітів'
				},
				status: {
					0: "Заблокована",
					1: "Активна"
				}
			}
		},
		transfer : {
			titleAccountSource: 'Звідки',
			titleAccountSourceHelper: 'Оберіть звідки',
			titleAccountDestination: 'Куди',
			titleAccountDestinationHelper: 'Оберіть куди',
			titleTransferButton: 'Виконати переказ',
			confirmTransfer: 'Ви дійсно бажаєте виконати цей переказ?'
		},
		reports: {
			titleTrnKind: 'Вид звіту',
			titleDate: 'Дата',
			titleCard: 'Карта',
			titleAddress: 'Адреса АЗС',
			titlePurse: 'Гаманець',
			titleQty: 'Кіл-ть',
			titlePrice: 'Ціна',
			titleSum: 'Сума',
			titleDiscount: 'Знижка',
			titleSumWithDiscount: 'Сума зі знижкой',
			titleName: 'Назва',
			titleUseFromDate: 'Від дати',
			titleUseToDate: 'До дати',
			titleSubmitXLS: 'Зберегти EXCEL',
			tittleFilterClear: 'Очистити'
		},
		billing: {
			fileName: 'Рахунок_від_%1%',
			typeFuel: 'Оплата за нафтопродукти',
			typeGoods: 'Оплата за товар',
			titleBtnCreateInvoice: 'Сформувати рахунок',
			titleLoadingFile: 'Формування рахунка...',
			titleLoadingFileError: "Помилка відображення предперегляду...",
			titleBtnSaveXLSX: 'Зберегти XLSX',
			titleBtnSavePDF: 'Зберегти PDF'
		},
		setting: {
			titleChangePass: 'Змінити пароль',
			titleChangeUser: 'Користувачі',
			titleAddNewUser: 'Додати нового користувача',
			users: {
				titleAccountId: 'ID',
				titleAccountRemark: 'Опис',
				titleFio: 'Прізвище, ім\'я',
				titleFirstName: 'Ім\'я',
				titleLastName: 'Прізвище',
				titlePhone: 'Телефон',
				titleEmail: 'Email',
				titleApiRole: 'Роль'
			}
		},
		dataGroup: {
			infoClient: 'Інформація клієнта',
			accounts: 'Рахунки',
			analytics: 'Аналітика',
			limits: 'Лімити',
			additionalInfo: 'Додаткова інформація',
			analyticInfo: 'Аналітика'
		},
		common: {
			table: {
				num: '#',
				active: 'Статус',
				filter: 'Фільтр',
				clearFilter: 'Очистити фильтр',
				emptyRows: 'Рядки відсутні',
				setting: 'Налаштування'
			},
			filter: {
				title: 'Фільтр',
				titleSubmit: 'Застосувати',
				titleStatus: 'Статус',
				titleIsActive: 'Активний',
				titleInactive: 'Не активний',
				titleIsBlock: 'Заблоковано',
				titleBalance: 'Баланс',
				titleNumCard: 'Номер карти',
				titlePhone: 'Телефон',
				titleVIN: 'Авто',
				titleFirstName: 'Ім\'я',
				titleLastName: 'Прізвище',
				titleFrom: 'Від',
				titleTo: 'До',
				titleAccountName: 'Назва',
				titleSelectAll: 'Всі'
			},
			title: {
				backToClients: 'Назад до списку клієнтів',
				backToCards: 'Назад до списку карт',
				backToAccounts: 'Назад до списку рахунків',
				titleClientComboBox: 'Клієнт',
				titleAccountComboBox: 'Рахунок',
				titleCards: 'Карти',
				titleDataNotFound: 'Дані не знайдені',
				titleNotInitialized: 'Не визначено',
				titleCancel: 'Відміна',
				titlePeriod: 'Період',
				titleDocumentation: 'Документація',
				titleLinks: 'Посилання',
				titleSearchStr: 'Пошукова строка',
				titleSelected: 'Обрано',
				titleNext: 'Далее',
				titleBack: 'Назад',
				titleCommit: 'Виконати',
				titleSum: 'Сума',
				titleOr: 'Або',
				titleCreate: 'Створити',
				titleDelete: 'Видалити',
			},
			modal: {
				type: {
					info: 'Інформація',
					success: 'Успішне виконання',
					warning: 'Попередження',
					error: 'Помилка',
					confirmation: 'Підтвердження',
					default: ''
				},
				labelConfirmation: 'Ви дійсно бажаєте видалити строку?'
			}
		}
	},
	statusClient: {
		0: "Активний",
		1: "Заблокований",
		2: "Видалений",
		3: "Переміщений"
	},
	error: {
		1: "Введені дані не є номером телефону",
		2: "Номер телефону не знайдено",
		3: "Не корректний OTP",
		4: "Користувач був зареєстрований раніше",
		5: "Користувач не знайдений",
		6: "Невірний пароль або номер телефону (email)",
		7: "Доступ до рахунку заблокований",
		8: "Помилкові параметри",
		9: "Помилка під час створення ліміту",
		10: "Не вдалось встановити новий пин",
		11: "Користувач був видален, зверніться до адміністратора",
		12: "Користувач був деактивован, зверніться до адміністратора",
		18: "Помилка оновлення ліміту",
		101: "Рахунок не належить клієнту",
		102: "Недостатньо коштів",
		1000: "Невідома помилка",
		1001: "Користувач не авторизован",
		1002: "Операція виконана успішно",
		1003: "Під час виконання сталася помилка",
		1004: "Не коректний номер телефону",
		1005: "Помилка запиту",
		1006: "Запит не авторизован",
		1007: "Заповнене поле не вірного формату",
		validation: {
			fieldRequired: 'Обов\'язкове поле',
			fieldErrorEmail: 'Некоректний email'
		}
	}
}
